import { FC } from 'react';
import { useField } from 'formik';
import { PlaygroundChatSection } from './PlaygroundChatSection';
import { PlaygroundConfig } from '../types/playgroundConfig';
import { PlaygroundVisionSection } from './PlaygroundVisionSection/PlaygroundVisionSection';

export const RenderPlaygroundContent: FC = () => {
  const [selectedType] = useField<PlaygroundConfig['type']>('type');
  if (selectedType.value === 'chat') {
    return <PlaygroundChatSection />;
  }
  return <PlaygroundVisionSection />;
};
